export function isAmountGreaterThanPercentage(
  amount1: number,
  amount2: number,
  percentage: number
): boolean {
  const threshold = amount2 * percentage;
  return amount1 > threshold;
}

export function accumulatedFibonacci(n: number) {
  if (n <= 0) return 0;

  let a = 1,
    b = 2; // start shifted sequence
  let sum = a;

  if (n === 1) return sum;

  sum += b;
  for (let i = 3; i <= n; i++) {
    [a, b] = [b, a + b];
    sum += b;
  }

  return sum;
}
